module.exports = __webpack_public_path__ + "img/文字背景1.cbfe9ea6.png";